import { SpinAndHoldCommonConfiguration } from "../../../api";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { BigSymbolSpinAndHoldBonus } from "./BigSymbolSpinAndHold";
export interface IBigSymbolSpinAndHoldBonusFactory
{
	CreateBigSymbolSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHoldBonus;
}

export class BigSymbolSpinAndHoldBonusFactory implements IBigSymbolSpinAndHoldBonusFactory
{
	public CreateBigSymbolSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHoldBonus
	{
		return new BigSymbolSpinAndHoldBonus(gameName, params, config);
	}
}